import { combineReducers } from 'redux'
import { all } from 'typed-redux-saga'
import {
	leadsSlice,
	leadOneSlice,
	leadUiSlice,
	leadActionsSlice,
	sberIdUserInfoSlice,
	leadTotalSlice,
} from './slices'
import { leadActionsSaga, leadOneSaga, leadsSaga, leadTotalSaga, sberIdUserInfoSaga } from './sagas'

export * from './slices'
export * from './sagas'
export * from './selectors'

export const new_leads = combineReducers({
	[leadsSlice.name]: leadsSlice.reducer,
	[leadOneSlice.name]: leadOneSlice.reducer,
	[leadUiSlice.name]: leadUiSlice.reducer,
	[leadTotalSlice.name]: leadTotalSlice.reducer,
	[leadActionsSlice.name]: leadActionsSlice.reducer,
	[sberIdUserInfoSlice.name]: sberIdUserInfoSlice.reducer,
})

export function* leadSaga() {
	yield* all([leadOneSaga(), leadActionsSaga(), leadsSaga(), leadTotalSaga(), sberIdUserInfoSaga()])
}
